import { ModuleWithProviders, NgModule } from '@angular/core';
import { Configuration } from './configuration';

@NgModule()
export class ConfigModule {
  static forRoot(
    configuration: Configuration
  ): ModuleWithProviders<ConfigModule> {
    return {
      ngModule: ConfigModule,
      providers: [
        {
          provide: Configuration,
          useValue: configuration,
        },
      ],
    };
  }
}
